import React, { useState } from "react";
import {
  BellRing,
  BookUser,
  ChevronDown,
  LogOut,
  UserRound,
} from "lucide-react";
import { t } from "@/i18n";
import DropdownMenu from "@/components/dropdownMenu";

import UserAvatar from "@/components/userAvatar";
import history from "@/interfaces/history";
import { PRIVATE_ADDRESS_BOOK_MODAL } from "../../constants/modals";
import { PeopleModalProvider } from "../shared/people-modal/people-modal.provider";
import { PeopleModalContainer } from "../shared/people-modal/people-modal.container";
import { PeopleModalHeader } from "../shared/people-modal/people-modal-header";
import { PersonalContactsGrid } from "../shared/people-modal/personal-contacts/PersonalConatctsGrid";
import { TAB_MY_PERSONAL_CONTACTS } from "../shared/select-user-modal/select-user-modal.constants";
import { CopyContactModalProvider } from "../shared/copy-contact/copy-contact-modal.provider";
import CopyContactToCompanyModal from "../shared/copy-contact/copy-contact-to-company-modal";
import { PeopleModalFooter } from "../shared/people-modal/people-modal-footer";
import { useMe } from "@/hooks/users/useMe";
const UserProfileMenuContainer = () => {
  const [isPrivateAddressModalOpen, setIsPrivateAddressModalOpen] =
    useState(false);

  const onClickItem = (item) => {
    if (item.modal === PRIVATE_ADDRESS_BOOK_MODAL) {
      setIsPrivateAddressModalOpen(true);
    } else {
      history.push(item.url);
    }
  };

  const closePrivateAddressbookModal = () => {
    setIsPrivateAddressModalOpen(false);
  };

  const { data: meQuery } = useMe();
  const me = meQuery?.data;

  if (!me) {
    return null;
  }

  return (
    <>
      <DropdownMenu
        trigger={
          <div className="group flex h-[40px] cursor-pointer items-center gap-2 px-4">
            <UserAvatar
              className="h-12 w-12"
              userId={me.id}
              userName={me.name}
            />
            <span className="max-w-[300px] truncate">{me.name}</span>
            <ChevronDown className="h-6 w-6 opacity-50" />
          </div>
        }
        options={[
          {
            label: t("menu.userMenu.profile"),
            icon: <UserRound />,
            onClick: () => history.push("/profile"),
          },
          {
            label: t("menu.user_menu.dropdown.item.private_address_book"),
            icon: <BookUser />,
            onClick: () => onClickItem({ modal: PRIVATE_ADDRESS_BOOK_MODAL }),
          },
          {
            label: t("menu.user_menu.dropdown.item.notification_preferences"),
            icon: <BellRing />,
            onClick: () => history.push("/notification-preferences"),
          },
          {
            label: t("menu.userMenu.logout"),
            icon: <LogOut />,
            onClick: () => history.push("/signout"),
          },
        ]}
      />
      {isPrivateAddressModalOpen && (
        <>
          <PeopleModalProvider
            isOpen={isPrivateAddressModalOpen}
            initialActiveTab={TAB_MY_PERSONAL_CONTACTS}
            canCopyToMultipleCompanyAddressbooks
          >
            <PeopleModalContainer
              headerComponent={() => (
                <PeopleModalHeader title="private_addressbook.title" />
              )}
              footerComponent={() => (
                <PeopleModalFooter
                  cancelButtonTid="generic.form.close"
                  onCancel={closePrivateAddressbookModal}
                />
              )}
            >
              <PersonalContactsGrid />
            </PeopleModalContainer>
          </PeopleModalProvider>

          <CopyContactModalProvider>
            <CopyContactToCompanyModal />
          </CopyContactModalProvider>
        </>
      )}
    </>
  );
};

export default UserProfileMenuContainer;
